"use client";

import { signOut } from "aws-amplify/auth";
import { deleteDocumentCookie } from "./cookie-utils";

// Define a utility function
export async function ClearProjectCookies() {
  if (process.env.PROJECT === "Whatuni") {
    try {
      sessionStorage.clear();
      localStorage?.removeItem("resultSubmit");
      deleteDocumentCookie([
        { name: "wcache" },
        { name: "USER_FAV_BASKET_COUNT" },
        { name: "Signinonetap", options: { domain: ".whatuni.com" } },
        { name: "LoginSession", options: { domain: ".whatuni.com" } },
        { name: "LogedinviaOnetap", options: { domain: ".whatuni.com" } },
      ]);
      try {
        await signOut({ global: true });
      } catch (err) {
        console.error("Sign out failed:", err);
      }

      window.location.href = "/degrees/userLogin.html?e=logout";
    } catch (error) {
      console.error("Whatuni logout failed:", error);
    }
  } else {
    try {
      sessionStorage.clear();
      try {
        deleteDocumentCookie([
          { name: "pgs_bskt_cnt" },
          { name: "pgs_x" },
          { name: "pgs_userid" },
          { name: "pgsuid" },
          { name: "pgsIdToken" },
          { name: "Signinonetap", options: { domain: ".postgraduatesearch.com" } },
          { name: "LoginSession", options: { domain: ".postgraduatesearch.com" } },
          { name: "LogedinviaOnetap", options: { domain: ".postgraduatesearch.com" } },
        ]);
      } catch (err) {
        console.error("Cookie deletion failed:", err);
      }
      try {
        await signOut({ global: true });
      } catch (err) {
        console.error("Sign out failed:", err);
      }

      window.location.href = "/";
    } catch (error) {
      console.error("PGS logout failed:", error);
    }
  }
}
